import window from 'global/window';

export const randomBetweenInterval = (min, max) => {
  return Math.random() * (max - min) + min;
}

export const isMobile = () => {
  return window.innerWidth < 700;
}